import { Card, CardContent, Typography, PaletteColor } from '@mui/material';
import { currentUserSessionAtom } from 'library/store';
import { useRecoilValue } from 'recoil';

interface KpiCardProps {
  title: string;
  value: number;
  paletteColor: PaletteColor;
  color?: string;
}

export const KpiCard = ({ title, value, color = '#1976d2', paletteColor}: KpiCardProps) =>  { 
  
  
  const {language: lg} = useRecoilValue(currentUserSessionAtom);

  const sValue = new Intl.NumberFormat( lg.includes('fr') ?  'fr-FR' : 'en-US').format(value);

  return (
  <Card sx={{ minWidth: 150, backgroundColor: paletteColor.light, color: paletteColor.dark }}>
    <CardContent>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="h4" fontWeight="bold">{sValue}</Typography>
    </CardContent>
  </Card>
  );
}